import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const userReferralMenuRegistry = {
    core_userReferral: {
        label: "User Referral",
        link: PAGE_URL.USER_REFERRAL_PAGE,
        key: PAGE_URL.USER_REFERRAL_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default userReferralMenuRegistry;
